// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgReceipt = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1.0125 0.0464864C0.784375 -0.0378886 0.525 -0.00663868 0.321875 0.133986C0.11875 0.274611 0 0.502736 0 0.749611V15.2496C0 15.4965 0.121875 15.7246 0.321875 15.8652C0.521875 16.0059 0.78125 16.0371 1.0125 15.9496L2.73125 15.3059L4.20312 15.9371C4.40625 16.0246 4.6375 16.0184 4.83437 15.9184L6 15.3371L7.16563 15.9184C7.3625 16.0184 7.59375 16.0246 7.79688 15.9371L9.26875 15.3059L10.9875 15.9496C11.2188 16.0371 11.475 16.0027 11.6781 15.8652C11.8812 15.7277 12 15.4965 12 15.2496V0.749611C12 0.502736 11.8781 0.274611 11.6781 0.133986C11.4781 -0.00663868 11.2188 -0.0378887 10.9875 0.0496113L9.26875 0.693361L7.79688 0.0621113C7.59375 -0.0253887 7.3625 -0.0191386 7.16563 0.0777364L6 0.662112L4.83437 0.0777364C4.6375 -0.0191386 4.40625 -0.0253886 4.20312 0.0589864L2.73125 0.690236L1.0125 0.0464864ZM1.5 14.1684V1.83086L2.4875 2.20274C2.66875 2.27149 2.86875 2.26524 3.04687 2.19024L4.47812 1.57774L5.66563 2.17149C5.87813 2.27774 6.125 2.27774 6.3375 2.17149L7.525 1.57774L8.95625 2.19024C9.13437 2.26524 9.33438 2.27149 9.51562 2.20274L10.5031 1.83399V14.1684L9.51562 13.7996C9.33438 13.7309 9.13437 13.7371 8.95625 13.8121L7.525 14.4246L6.3375 13.8309C6.125 13.7246 5.87813 13.7246 5.66563 13.8309L4.47812 14.4246L3.04687 13.8121C2.86875 13.7371 2.66875 13.7309 2.4875 13.7996L1.5 14.1684ZM3.75 4.24961C3.33437 4.24961 3 4.58399 3 4.99961C3 5.41524 3.33437 5.74961 3.75 5.74961H8.25C8.66563 5.74961 9 5.41524 9 4.99961C9 4.58399 8.66563 4.24961 8.25 4.24961H3.75ZM3.75 10.2496C3.33437 10.2496 3 10.584 3 10.9996C3 11.4152 3.33437 11.7496 3.75 11.7496H8.25C8.66563 11.7496 9 11.4152 9 10.9996C9 10.584 8.66563 10.2496 8.25 10.2496H3.75ZM3 7.99961C3 8.41524 3.33437 8.74961 3.75 8.74961H8.25C8.66563 8.74961 9 8.41524 9 7.99961C9 7.58399 8.66563 7.24961 8.25 7.24961H3.75C3.33437 7.24961 3 7.58399 3 7.99961Z"
      fill="currentColor"
    />
  </svg>
);
export { SvgReceipt };
